module.exports = __webpack_public_path__ + "static/media/LBRA.f5c35a1e.svg";